var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"watermark",rawName:"v-watermark",value:({text:_vm.userName}),expression:"{text:userName}"}],staticClass:"full-h",attrs:{"id":"app"}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }